import type { flightEntity } from 'freedom-shared';

import { dateUtils } from '../../shared/lib';

const connectionDuration = (segment: flightEntity.types.MappedSegment) => {
  const durationInSeconds = segment.connection?.duration;
  if (!durationInSeconds) {
    return null;
  }

  return dateUtils.prettyDurationFromSeconds(durationInSeconds);
};

const isSelfTransfer = (segment: flightEntity.types.MappedSegment) => {
  const guarantor = segment.connection?.guarantor;
  return guarantor === null || guarantor === 'tenant';
};

const hasNextDayDep = (segment: flightEntity.types.MappedSegment) => {
  const [hours, minutes] = segment.arr.time.split(':');
  const duration = segment.connection?.duration;
  const durationInHours = !duration ? 0 : duration / 3600;
  const nextDepHours =
    parseInt(hours) + parseInt(minutes) / 60 + durationInHours;

  return nextDepHours > 24;
};

export const flightConnectionLib = {
  connectionDuration,
  isSelfTransfer,
  hasNextDayDep,
};
